import { useCallback } from "react"

import { useParams } from "react-router-dom"

import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { useExistingRiskZoneCluster } from "../../hooks/queries/useRiskZoneClusters"

export const RiskZoneValidator = (props) => {
    const { children } = props
    const { road, riskZoneId } = useParams()
    const navigate = useNavigateWithSearchParams()

    const navigateBack = useCallback(() => {
        return navigate(`../${road}`)
    }, [navigate, road])

    const filterInt = (value) => {
        if (/^(-|\+)?(\d+|Infinity)$/.test(value)) {
            return Number(value)
        }
        return NaN
    }

    const existingRiskZone = useExistingRiskZoneCluster(filterInt(riskZoneId), navigateBack)

    if (!existingRiskZone) {
        return null
    }

    return children
}